/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Insert = (props: IconProps) => (
  <Icon {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M2 3C0.895431 3 0 3.89543 0 5V19C0 20.1046 0.89543 21 2 21H22C23.1046 21 24 20.1046 24 19V5C24 3.89543 23.1046 3 22 3H2ZM5 6C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18H19C20.1046 18 21 17.1046 21 16V8C21 6.89543 20.1046 6 19 6H5Z" />
    <circle cx="18" cy="9" r="1" />
    <rect x="5" y="9" width="9" height="2" rx="1" />
    <rect x="5" y="13" width="6" height="2" rx="1" />
  </Icon>
);
